/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectStateData } from 'src/core/redux/selectors';
import { selectFileData } from 'src/components/OligoDNA/components/UploadPlateTemplate/selectors';
import {
  PLATE_SIZE_DETAILS_NAMESPACE,
  NORMALIZATION_ALIQUOTS_NAMESPACE,
  PLATE_POOLING_NAMESPACE,
  REMAINDERS_NAMESPACE,
} from 'src/constants/forms';

export default (WrappedComponent) => {
  const Component = (props) => (
    <WrappedComponent
      {...{
        ...props,
        dnaData: {
          file: props.file,
          [PLATE_SIZE_DETAILS_NAMESPACE]: props[PLATE_SIZE_DETAILS_NAMESPACE],
          [NORMALIZATION_ALIQUOTS_NAMESPACE]:
            props[NORMALIZATION_ALIQUOTS_NAMESPACE],
          [PLATE_POOLING_NAMESPACE]: props[PLATE_POOLING_NAMESPACE],
          [REMAINDERS_NAMESPACE]: props[REMAINDERS_NAMESPACE],
        },
      }}
    />
  );

  Component.propTypes = {
    file: PropTypes.object,
    plateSizeDetails: PropTypes.object,
    normalizationAliquotsDetails: PropTypes.object,
    platePoolingDetails: PropTypes.object,
  };

  const mapStateToProps = (state) => ({
    file: selectFileData(state),
    [PLATE_SIZE_DETAILS_NAMESPACE]: selectStateData(
      PLATE_SIZE_DETAILS_NAMESPACE
    )(state),
    [NORMALIZATION_ALIQUOTS_NAMESPACE]: selectStateData(
      NORMALIZATION_ALIQUOTS_NAMESPACE
    )(state),
    [PLATE_POOLING_NAMESPACE]: selectStateData(PLATE_POOLING_NAMESPACE)(state),
    [REMAINDERS_NAMESPACE]: selectStateData(REMAINDERS_NAMESPACE)(state),
  });

  return connect(mapStateToProps)(Component);
};
